import React, { useState, useRef, useEffect } from 'react';
import { TextField, Button, CircularProgress, Container, Box, Typography } from '@mui/material';
import axios from 'axios';
import { useSnackbar } from '../providers/SnackBarProvider';
import { handleError, validateEmail, verifyCaptchaToken } from '../utils/lib';
import './styles.css';
import ReCAPTCHA from 'react-google-recaptcha';
import { useTranslation } from 'react-i18next';

function LoginForgotPassword() {    
  const { t } = useTranslation();
  const showSnackbar = useSnackbar();

  const [isLoading, setIsLoading] = useState(false);

  const recaptcha = useRef();

  const [email, setEmail] = useState('');
  const [errors, setErrors] = useState({});
  const [refs] = useState({
    email: useRef(null),
  });
 
  const info = t('login.checkEmailToContinue');
  const [isSuccess, setIsSuccess] = useState(false);

  useEffect(() => {
    // Add a delay to focus to ensure component is fully rendered
    setTimeout(() => {
      if (refs.email.current) {
        refs.email.current.focus();
      }
    }, 100);
  }, []);

  const handleSubmit = async() => {
    if (!validateEmail('email', email, setErrors, refs.email))
      return;

    const captchaValue = recaptcha.current.getValue();
    if (!captchaValue) {
      showSnackbar(t('login.captchaRequired'));
      return;
    } 
    
    const validCaptcha = verifyCaptchaToken(captchaValue);
    if (!validCaptcha) {
      showSnackbar(t('login.captchaErrorDot'));
      return;
    }

    setIsLoading(true);
    
    try {
      const response = await axios.post(`${import.meta.env.VITE_API_URL}users?forgot_account_web`, { email });
      if (response.data.status == 'SUCCESS') {
        showSnackbar(t('login.checkEmailWithAddress', { email }));
        setIsSuccess(true);
      }
    } catch (error) {
      handleError(error, showSnackbar);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Container maxWidth="sm">
      <Box className="login-container">
        <Box 
          className="login-form" 
          padding={3} 
          boxShadow={3}
          >

          <TextField
            label={t('login.email')}
            fullWidth
            margin="normal"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            error={!!errors.email}
            helperText={errors.email}
            inputRef={refs.email}
          />

          <Box display="flex" justifyContent="center" mt={2}>
            <ReCAPTCHA 
              ref={recaptcha} 
              sitekey={import.meta.env.VITE_RECAPCHA_SITE_KEY} 
            />
          </Box>

          {isSuccess && <Typography variant="subtitle1" sx={{ mt: 4, textAlign: 'center' }} fullWidth >{info}</Typography>}

          {!isSuccess && 
            <Box mt={4}>
              <Button
                variant="contained"
                type="submit"
                color="primary"
                onClick={handleSubmit}
                disabled={isLoading}
                fullWidth
              >
                {isLoading ? <CircularProgress size={24} /> : t('common.continue')}
              </Button>
            </Box>
          }        
        </Box>
      </Box>
    </Container>
  );
}

export default LoginForgotPassword;